import { getEditorCanvas } from 'js/editor/EditorCanvas/EditorCanvas';

export async function clearCanvasSelectionReadyForUpdates() {
  const editorCanvas = getEditorCanvas();
  if (editorCanvas) {
    await editorCanvas.discardActiveObjectAndWaitForNextEventLoop();
  }
}
